module.exports = __webpack_public_path__ + "media/images/number_6-6a8490fb744009fb45750143e3bb1bd3.png";